export default (pages) => {
  const list = [];
  for (let key in pages || {}) {
    const page = pages[key];
    list.push(page);
  }
  return list.sort((a, b) => a.sort - b.sort);
}
